import React from 'react';
import { isIOS, isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import SideBar from './SideBar';
import MobileHeader from './MobileHeader';

const Vertical = ({ children }) => {
  // set default height and overflow for iOS mobile Safari 10+ support.
  if (isIOS && isMobile) {
    document.body.classList.add('ios-mobile-view-height');
  } else if (document.body.classList.contains('ios-mobile-view-height')) {
    document.body.classList.remove('ios-mobile-view-height');
  }

  return (
    <div className="app-container fixed-drawer">
      <SideBar />
      <div className="app-main-container">
        <MobileHeader />
        <main className="app-main-content-wrapper">
          <div className="app-main-content">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

Vertical.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Vertical;
